import { render } from "./EventCardAdd.vue?vue&type=template&id=9fe22ad4"
import script from "./EventCardAdd.vue?vue&type=script&lang=js"
export * from "./EventCardAdd.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__